import { queryFilter, type RowFilter } from '../domain/rowFilter.js';
import { useTRPC } from '../utils/trpc.js';
import { CURSOR_PAGING, PAGE_SIZE, usePagedRows } from './usePagedRows.js';

/**
 * The Games page's rows, 50 at a time: every studio's games, or one studio's when `studio` is
 * given. The same filter shape the Studios page uses (`hooks/useStudioRows.ts`), so *Needs
 * attention* narrows both alike — both built on `usePagedRows`.
 */
export const useGameRows = (studio: string | null, filter: RowFilter) => {
    const trpc = useTRPC();
    return usePagedRows(
        trpc.games.list.infiniteQueryOptions(
            {
                ...(studio ? { studio } : {}),
                limit: PAGE_SIZE,
                ...queryFilter(filter),
            },
            CURSOR_PAGING,
        ),
    );
};
